import type { CustomFlowbiteTheme } from 'flowbite-react';

export const megaMenuTheme: CustomFlowbiteTheme['megaMenu'] = {
  root: {
    base: 'bg-white px-2 py-2.5 sm:px-4',
    rounded: {
      on: 'rounded',
      off: '',
    },
    bordered: {
      on: 'border',
      off: '',
    },
    inner: {
      base: 'mx-auto flex flex-wrap items-center justify-between',
      fluid: {
        on: '',
        off: 'container',
      },
    },
  },
  brand: {
    base: 'flex items-center',
  },
  collapse: {
    base: 'w-full md:block md:w-auto',
    list: 'mt-4 flex flex-col md:mt-0 md:flex-row md:space-x-8 md:text-sm md:font-medium',
    hidden: {
      on: 'hidden',
      off: '',
    },
  },
  link: {
    base: 'block py-2 pl-3 pr-4 md:p-0',
    active: {
      on: 'bg-titan-folly-700 text-white md:bg-transparent md:text-titan-folly-700',
      off: 'border-b border-titan-night-100 text-titan-night-700 hover:bg-titan-night-50 md:border-0 md:hover:bg-transparent md:hover:text-titan-folly-700',
    },
    disabled: {
      on: 'text-titan-night-400 hover:cursor-not-allowed',
      off: '',
    },
  },
  toggle: {
    base: 'inline-flex items-center rounded-lg p-2 text-sm text-titan-night-500 hover:bg-titan-night-100 focus:outline-none focus:ring-2 focus:ring-titan-night-200 md:hidden',
    icon: 'h-6 w-6 shrink-0',
  },
  dropdown: {
    base: '',
    toggle: {
      arrowIcon: 'ml-2 h-4 w-4',
      content: 'py-1 focus:outline-none',
      floating: {
        animation: 'transition-opacity',
        arrow: {
          base: 'absolute z-10 h-2 w-2 rotate-45',
          style: {
            dark: 'bg-titan-night-900',
            light: 'bg-white',
            auto: 'bg-white',
          },
          placement: '-4px',
        },
        base: 'z-10 w-fit divide-y divide-titan-night-100 rounded shadow focus:outline-none mt-2 block',
        content: 'py-1 text-sm text-titan-night-500',
        divider: 'my-1 h-px bg-titan-night-100',
        header: 'block px-4 py-2 text-sm text-titan-night-700',
        hidden: 'invisible opacity-0',
        item: {
          container: '',
          base: 'flex w-full cursor-pointer items-center justify-start px-4 py-2 text-sm text-titan-night-700 hover:bg-titan-night-100 focus:bg-titan-night-100 focus:outline-none',
          icon: 'mr-2 h-4 w-4',
        },
        style: {
          dark: 'bg-titan-night-900 text-white',
          light: 'border border-titan-night-200 bg-white text-titan-night-900',
          auto: 'border border-titan-night-200 bg-white text-titan-night-500',
        },
        target: 'w-fit',
      },
      inlineWrapper: 'flex w-full items-center justify-between',
    },
  },
  dropdownToggle: {
    base: 'py-2 pl-3 pr-4 md:p-0 border-b border-titan-night-100 text-titan-night-700 hover:bg-titan-night-50 md:border-0 md:hover:bg-transparent md:hover:text-titan-folly-700 flex w-full items-center justify-between',
  },
};
